const feedback = (fetcher) => ({
  createFeedBack: (feedback_details, feedback_option) =>
    fetcher('/feedbacks', {
      method: 'POST',
      body: { feedback_details, feedback_option },
    }),
})

export default feedback
